module.exports = __webpack_public_path__ + "img/contact_clerk.24a262bf.png";